import { pluralize } from "common/utils/format/word";

// eslint-disable-next-line import/prefer-default-export
export const generateTimeRemainingText = (cutoff, short = false) => {
  const curTime = Date.now();
  const diff = Math.floor((cutoff - curTime) / 1000);

  if (curTime >= cutoff) {
    return "";
  }

  const days = Math.floor(diff / 86400); // 86400 = seconds in a day
  const hours = Math.floor(diff / 3600) - days * 24;
  const minutes = Math.floor(diff / 60) - (days * 24 + hours) * 60;

  let text = "";

  if (days) {
    text += `${pluralize(days, "day")} `;
  }
  if (hours) {
    text += `${pluralize(hours, short ? "hr" : "hour")} `;
  }
  if (minutes) {
    text += short ? `${minutes} min` : `${pluralize(minutes, "minute")}`;
  }
  if (text === "") {
    text = "less than a minute";
  }

  return text;
};
